"use client";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { Button } from "../Button";
import classes from "./pagination.module.css";

const PaginationComponent = ({
  totalRecord,
  currentPage,
  setCurrentPage,
  totalPagesToDisplay = 10,
  totalPages,
}) => {
  const showLeftEllipsis = currentPage - 1 > totalPagesToDisplay / 2;
  const showRightEllipsis =
    totalPages - currentPage + 1 > totalPagesToDisplay / 2;
  const getPageNumbers = () => {
    if (totalPages <= totalPagesToDisplay) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      const half = Math.floor(totalPagesToDisplay / 2);
      let start = currentPage - half;
      let end = currentPage + half;
      if (start < 1) {
        start = 1;
        end = totalPagesToDisplay;
      }
      if (end > totalPages) {
        start = totalPages - totalPagesToDisplay + 1;
        end = totalPages;
      }
      if (showLeftEllipsis) {
        start++;
      }
      // If showRightEllipsis is true, add an ellipsis after the end page
      if (showRightEllipsis) {
        end--;
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  };

  const renderPaginationItems = () => {
    const pageNumbers = getPageNumbers();
    return pageNumbers.map((pageNumber) => (
      <Button
        key={pageNumber}
        onClick={() => {
          setCurrentPage(pageNumber);
        }}
        className={
          pageNumber === currentPage ? classes.active : classes.inactive
        }
        variant="page"
      >
        {pageNumber}
      </Button>
    ));
  };

  return (
    <div className={classes.paginationContainer}>
      <p>
        {" "}
        Showing {currentPage * totalPagesToDisplay -
          totalPagesToDisplay +
          1} -{" "}
        {currentPage * totalPagesToDisplay > totalRecord
          ? totalRecord
          : currentPage * totalPagesToDisplay}{" "}
        of {totalRecord || totalPages * totalPagesToDisplay}
      </p>
      <div className={classes.pagination}>
        <Button
          onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
          aria-disabled={currentPage === 1}
          variant="link"
        >
          <FaChevronLeft color="#8B909A" />
        </Button>
        {showLeftEllipsis && <span className={classes.ellipsis}>...</span>}
        {renderPaginationItems()}
        {showRightEllipsis && <span className={classes.ellipsis}>...</span>}
        <Button
          onClick={() =>
            currentPage < totalPages && setCurrentPage(currentPage + 1)
          }
          variant="link"
        >
          <FaChevronRight color="#8B909A" />
        </Button>
      </div>
    </div>
  );
};

export default PaginationComponent;
